import React from "react";
import GameSsoLoginCallBack from "Utils/GameSsoLoginCallBack";
import { useLocation } from "react-router-dom";


const SsoCallBackNaver = () => {
    const location= useLocation();  
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }
    let query =serchParamsFunc();
    let getGameSvcCd = query.get("gameSvcCd");
    let redirectUri = query.get("redirectUri");
    GameSsoLoginCallBack("naver",getGameSvcCd,redirectUri);
    return(
        <></>
    )
}

export default SsoCallBackNaver;